<template>
  <div class="container">
    <w-nav-bar class="navbar" @mobileLeftBtn="toCvs" />
    <div class="code-container">
      <div class="qr-code">
        <img :src="mentorType === 'selfSupport' ? 'https://files.wondercv.com/mentor/self-support.png' : 'https://files.wondercv.com/mentor/password.png'" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import WNavBar from '../../components/global/w-navbar'
export default {
  name: "MentorTemplate",
  components: {
    WNavBar
  },
  data() {
    return {
      /**
       * 导师类型(mentorType)：
       * 1. selfSupport   自营导师
       * 2. password   职场密码导师
       * **/
      mentorType: this.$route.query.mentorType || 'selfSupport'    // 导师类型
    }
  },
  methods: {
    toCvs() {
      this.$router.replace('/cvs')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  background-color: #ff6644;
  box-sizing: border-box;
  padding-top: 44px;
  overflow: hidden;
  .navbar {
    width: 100%;
    height: 44px;
    background-color: #fff;
  }
  .code-container {
    width: 100%;
    height: calc(100vh - 44px);
    //background-color: #fff;
    .qr-code {
      width: 100%;
      height: 443px;
      margin-top: 40px;
      background: url("https://files.wondercv.com/mentor/mentorQrCode.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      img {
        width: 200px;
        height: 200px;
        object-fit: contain;
        position: absolute;
        left: 50%;
        top: 85px;
        transform: translateX(-50%);
      }
    }
  }
}
</style>